const { useCheckIsSuperAdmin } = require('hooks');
const { SUB_ADMIN_GROUP_PERMISSION } = require('./constants');

export const useCheckDisabledAddDeletePermission = () => {
  const isSuperAdmin = useCheckIsSuperAdmin();

  const checkDisabledAddDeletePermissionBtn = (permission) => {
    return !isSuperAdmin && SUB_ADMIN_GROUP_PERMISSION.includes(permission);
  };

  const filterNonSubAdminPermissions = (permissionList) => {
    if (isSuperAdmin) return permissionList;
    else {
      return permissionList.filter(
        (permissionItem) =>
          !SUB_ADMIN_GROUP_PERMISSION.includes(permissionItem?.permissionName)
      );
    }
  };

  return {
    checkDisabledAddDeletePermissionBtn,
    filterNonSubAdminPermissions,
    isSuperAdmin,
  };
};
